import { CircleDollarSign } from "lucide-react";
import { Link } from "react-router-dom";

import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { DIAGNOSIS_RULE_OPTIONS } from "../constants";
import { formatCurrency, formatNumber } from "../helpers";
import { EmptyState } from "../components/EmptyState";
import { RuleBadge } from "../components/RuleBadge";
import { SectionCard } from "../components/SectionCard";
import { SectionError } from "../components/SectionError";

function ResultLine({ label, value, strong = false }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-gray-100 py-2 last:border-0">
      <span className="text-sm text-gray-600">{label}</span>
      <span className={strong ? "font-semibold text-gray-900" : "font-medium text-gray-800"}>{value}</span>
    </div>
  );
}

export function FinancialSummary() {
  const controller = CrmPetDiagnosisController();
  const byRule = useCrmPetDiagnosis((state) => state.data.overviewByRule);
  const loading = useCrmPetDiagnosis((state) => state.data.loading.diagnosisSummary);
  const error = useCrmPetDiagnosis((state) => state.data.errors.diagnosisSummary);
  const filters = useCrmPetDiagnosis((state) => state.data.filters.overview);

  return (
    <SectionCard
      title="Resultado por régua"
      description="Tentativas multirrégua aparecem em todas as réguas selecionadas; totais abaixo não devem ser somados."
      icon={CircleDollarSign}
    >
      {error && (
        <SectionError message={error} onRetry={() => controller.retrySection("diagnosisSummary")} />
      )}
      {!error && loading && <div className="h-64 animate-pulse rounded-md bg-gray-100" />}
      {!error && !loading && !byRule && <EmptyState title="Sem resultados no período" />}
      {!error && !loading && byRule && (
        <div className="grid gap-4 xl:grid-cols-2">
          {DIAGNOSIS_RULE_OPTIONS.map((rule) => {
            const kpis = byRule[rule.value] || {};
            const link = `/diagnosis/crm-pet?tab=results&resultsPeriod=${filters.period}&resultsFrom=${filters.from}&resultsTo=${filters.to}&resultsRule=${rule.value}`;
            return (
              <article key={rule.value} className="rounded-lg border border-gray-200 p-4">
                <div className="mb-2 flex items-center justify-between gap-3">
                  <RuleBadge ruleCode={rule.value} />
                  <Link className="text-xs font-medium text-primary hover:underline" to={link}>Detalhar</Link>
                </div>
                <ResultLine label="Clientes contatados" value={formatNumber(kpis.contactedAttempts)} />
                <ResultLine label="Contatos realizados" value={formatNumber(kpis.contactsMade)} />
                <ResultLine label="Tiveram agendamento" value={formatNumber(kpis.scheduledCustomers)} />
                <ResultLine label="Finalizaram atendimento" value={formatNumber(kpis.finishedCustomers)} />
                <ResultLine label="Receita de serviços" value={formatCurrency(kpis.serviceRevenue)} />
                <ResultLine label="Receita de produtos" value={formatCurrency(kpis.productRevenue)} />
                <ResultLine label="Receita atribuída" value={formatCurrency(kpis.totalRevenue)} strong />
              </article>
            );
          })}
        </div>
      )}
    </SectionCard>
  );
}
